// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".b045150d57aee8fe6334b62542ddd460430e60bb.chunk.js";
};